import { Dialog as BaseDialog } from "@base-ui/react/dialog"
import { TimeSlider } from "@vidstack/react"
import { TooltipContent, TooltipProvider, Tooltip as TooltipRoot, TooltipTrigger } from "@iyk/ui"

// @iyk/music-ui components
export * from "./components/Accordion"
export * from "./components/Alert"
export * from "./components/AnimateNumberCount"
export * from "./components/ArtistAvatar"
export * from "./components/ArtistAvatarName"
export * from "./components/AuthLayout"
export * from "./components/Avatar"
export * from "./components/Card"
export * from "./components/claim-flow/ClaimFlowShell"
export * from "./components/claim-flow/CollectedXP"
export * from "./components/claim-flow/Summary"
export * from "./components/claim-flow/TheatreCarousel"
export * from "./components/claim-flow/TheatreCarouselDialog"
export * from "./components/claim-flow/Xp"
export * from "./components/ContentUnlockBadge"
export * from "./components/Dialog"
export * from "./components/Drawer"
export * from "./components/DrawerDropdown"
export * from "./components/ErrorBoundary"
export * from "./components/FeedMediaController"
export * from "./components/forms/Checkbox"
export * from "./components/forms/CheckboxField"
export * from "./components/forms/Combobox"
export * from "./components/forms/file/File"
export * from "./components/forms/file/UploadType"
export * from "./components/forms/file/useSingleUpload"
export * from "./components/forms/FormCard"
export * from "./components/forms/phone/PhoneField"
export * from "./components/forms/RadioGroup"
export * from "./components/forms/Switch"
export * from "./components/forms/TextField"
export * from "./components/forms/UrlField"
export * from "./components/LoadingImage"
export * from "./components/InputOtp"
export * from "./components/LottiePlayer"
export * from "./components/MediaCarousel"
export * from "./components/MediaDialog"
export * from "./components/Meta"
export * from "./components/MusicProviders"
export * from "./components/Pagination"
export * from "./components/releases/AudioContext"
export * from "./components/releases/AudioPlayer"
export * from "./components/releases/AudioPlayerState"
export * from "./components/releases/PlaybackIcons"
export * from "./components/releases/PlaybackProgress"
export * from "./components/releases/PlayPauseButton"
export * from "./components/releases/Release"
export * from "./components/releases/Time"
export * from "./components/releases/Track"
export * from "./components/ScrollArea"
export * from "./components/Sheet"
export * from "./components/story-carousel/StoryCarousel"
export * from "./components/Table"
export * from "./components/Tabs"
export * from "./components/taps/DetailCard"
export { ToastAction } from "./components/Toast"
export * from "./components/unlocks-reveal/BackgroundSparkleGrid"
export * from "./components/unlocks-reveal/CardStack"
export * from "./components/unlocks-reveal/UnlocksReveal"
export * from "./components/UserAvatar"
export * from "./components/UserMenu"
export * from "./components/VerifiedBadge"
export * from "./components/VideoPlayer"
export * from "./components/WorldProfileBanner"
export * from "./components/WorldProfileFooter"
export * from "./components/WorldProfileTabs"
export * from "./components/XPLogo"
export * from "./satori/ProductItemClaimProof"
export * from "./satori/ShowCheckInProof"

export * from "./files/ImageCdn"
export * from "./files/MimeType"
export * from "./satori/styles"
export * from "./satori/WorldId"

// @iyk/music-ui hooks
export * from "./hooks/useCurrentPosition"
export * from "./hooks/useDerivedState"
export * from "./hooks/useDialogQueryState"
export * from "./hooks/useIntersectionObserver"
export * from "./hooks/useMediaQuery"
export * from "./hooks/useMounted"
export * from "./hooks/useObjectURL"
export * from "./hooks/usePermissions"
export * from "./hooks/usePreventContextMenu"
export * from "./hooks/useToast"

// @iyk/music-ui icons
export * as MusicIcon from "./icons"

// @iyk/music-ui assets
export { Assets } from "./Assets"

// @iyk/music-ui utilities
export * from "./colors/HexColor"
export * from "./Typography"

export const Primitive = {
  Dialog: BaseDialog,
  TimeSlider
}

// @iyk/ui components
export {
  Badge,
  BlinkingCursor,
  Breadcrumbs,
  Button,
  ButtonGroup,
  CarouselV2 as Carousel,
  DescriptionList,
  Dropdown,
  Field,
  Fieldset,
  Icon,
  Label,
  LinesShader,
  Link,
  Pixelation,
  Select,
  Sidebar,
  Textbox,
  TextboxAffix,
  Validity
} from "@iyk/ui"

export const Tooltip = {
  Root: TooltipRoot,
  Trigger: TooltipTrigger,
  Content: TooltipContent,
  Provider: TooltipProvider
}

// @iyk/ui classes
export { classForButton, classForLink } from "@iyk/ui"

// @iyk/ui utilities
export { cva, cx, defaultAvatarSVG } from "@iyk/ui"
